export default "__VITE_ASSET__e2d6d9b7__"